import CarrierCard from './carrier-card';

export default CarrierCard;
